import { LiveAnnouncer } from '@angular/cdk/a11y';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { OrdenServicioModel } from 'src/app/model/file/model.file';
import { AventuraService } from 'src/app/services/api/aventura.service';
import { FileService } from 'src/app/services/api/file.service';
import { LoadingService } from 'src/app/services/loading.service';

import { DialogFormComponent } from '../dialog-form/dialog-form.component';

@Component({
  selector: 'app-anulacion-os',
  templateUrl: './anulacion-os.component.html',
  styleUrls: ['./anulacion-os.component.css']
})
export class AnulacionOsComponent implements OnInit {

  startDate: Date | any;
  endDate: Date | any;
  startDate2: Date | any;
  endDate2: Date | any;
  model: any
  startDateSelected: Date | any;
  endDateSelected: Date | any;
  startDateSelected2: Date | any;
  endDateSelected2: Date | any;

  data: any;
  dataOs: any;

  selectedCliente: string | null = null;
  selectFile: string | null = null;
  selectProveedor: string | null = null;
  selectService: string | null = null;
  selectEstadoOS: string | null = null;
  selectOS: string | null = null;
  selectEstadoFile: string | null = null;

  arrayFiles: any = [];
  arrayClientes: any = [];
  arrayProveedores: any = [];
  arrayServices: any = [];
  arrayEstadoFiles: any = ['APROBADO', 'NO APROBADO', 'NUEVO PEDIDO', 'ANULADO', 'POSTERGADO', 'EN PROCESO', 'CONFIRMADO', 'RECONFIRMADO', 'PROGRAMADO', 'EN OPERACION', 'OPERADO', 'CERRADO'];
  arrayOS: any = [];
  arraySelectEstadoOS: any = ['PAGADO', 'EN ESPERA'];

  loader: boolean = false
  osDataSource = new MatTableDataSource<OrdenServicioModel>();
  osDisplayedColumns: string[] =
    ['estadoFile', 'fileNumber', 'numberOS', 'estadoOS', 'nameEmpresa', 'nameProveedor', 'createdAt',
      'fechaPago', 'monto', 'moneda', 'actions'];
  @ViewChild(MatPaginator) set paginator(value: MatPaginator) {
    this.osDataSource.paginator = value;
  }
  @ViewChild(MatSort) set sort(value: MatSort) {
    this.osDataSource.sort = value;
  }


  constructor(private aventuraService: AventuraService, public dialog: MatDialog, private _liveAnnouncer: LiveAnnouncer, private fileService: FileService, private changeDetectorRefs: ChangeDetectorRef, public loadingService: LoadingService, private http: HttpClient) { }

  ngOnInit(): void {
    this.loader = true
    this.loadMain();
  }

  async loadMain() {


    this.fileService?.getAllOSProvider()?.subscribe(async (dataOS) => {
      console.log('data de all OS', dataOS);


      ///////////////////////////////////////////////////
      let listOS = [];
      let allOSDialog = dataOS.getAllOS
      let unique = [...new Set(allOSDialog.map((item: any) => item.numberOS))];
      console.log('uni', unique);

      for (let i = 0; i < unique.length; i++) {
        let objOS: any = {};
        objOS.numberOS = unique[i];
        objOS.listServicios = [];
        objOS.monto = 0;
        await Promise.all(allOSDialog.map(async (item: any) => {

          if (unique[i] === item.numberOS) {
            //console.log('itemitem',item)
            objOS.estadoOS = item.estadoOS;
            objOS.nameEmpresa = item.nameEmpresa;
            objOS.nameProveedor = item.nameProveedor;
            objOS.codigoReserva = item.codigoReserva;
            objOS.usuario = item.usuario;
            objOS.tipoProveedor = item.tipoProveedor;
            objOS.estadoFile = item.estadoFile;
            objOS.idItinerary = item.idItinerary;
            objOS.numberFile = item.numberFile;
            objOS.group = item.group;
            objOS.fechaPago = item.fechaPago;
            objOS.createdAt = item.createdAt;
            objOS.moneda = item.monedaTarifa;
            objOS.monto = objOS.monto + item.totalGeneral;
            objOS.listServicios.push(item.servicio);
          }
        }));

        console.log('objOS', objOS)

        /*                   objOS.createdAt=objOS.listServicios[0].createdAt;
                objOS.fechaOperacion = objOS.listServicios[0].fechaOperacion;
                objOS.fechaPago = objOS.listServicios[0].fechaPago; */
        objOS.saf = 0;
        objOS.efectivo = objOS.monto;
        objOS.disabled = true;

        listOS.push(objOS);
      }

      console.log("listos")
      //console.log(listOS)

      const filterEstado = listOS.filter(os => os.estadoOS === "PAGADO" || os.estadoOS === "CERRADO")
      console.log(filterEstado)

      const dataResult = filterEstado.map((item) => ({ ...item, check: false, cantPax: item?.servicio?.cantPax }))


      console.log(dataResult)

      ///////////////////////////////////////////
      this.model = dataResult
      console.log(this.model)

      let numOS = (dataResult.map((item: any) => (item.numberOS)))
      const proveedor = dataResult.map((item: any) => (item.nameProveedor))
      // const services = this.model.map((item: any) => (item.lstServicios.servicio))
      const cliente = dataResult.map((item: any) => (item.nameEmpresa))
      // console.log(cliente)
      const files = dataResult.map((item: any) => (item.numberFile))
      this.arrayFiles = [...new Set(files)]
      this.arrayOS = [...new Set(numOS)]
      this.arrayClientes = [...new Set(cliente)]
      this.arrayProveedores = [...new Set(proveedor)]
      // this.arrayServices = [...new Set(services)]

      this.osDataSource = new MatTableDataSource(this.model);
      this.osDataSource.paginator = this.paginator;
      this.osDataSource.sort = this.sort;
      this.changeDetectorRefs.detectChanges();
      this.loader = false
      console.log("Files");
      // console.log(data);
    });
  }

  ngAfterViewInit() {
    /*   this.fileDataSource.paginator = this.paginator;
      this.fileDataSource.sort = this.sort;
      this.changeDetectorRefs.detectChanges(); */
  }



  applyFilter(event: Event) {
    let filterValue = (event.target as HTMLInputElement).value;
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.osDataSource.filter = filterValue;
  }



  openDialog(os: any): void {
    let dialogRef = this.dialog.open(DialogFormComponent, {
      width: '800px',
      height: "600px",
      data: {
        fileNumber: os.numberFile,
        nameProveedor: os.nameProveedor,
        numberOS: os.numberOS,
        idItinerary: os.idItinerary,
        moneda: os.moneda,
        monto:os.monto
      }
    });

    dialogRef.afterClosed().subscribe((data) => {

      if (data) {
        this.ngOnInit()
      }
      console.log(data)
      console.log('The dialog was closed');
      // this.animal = result;
    });
  }


  traslateEstado(estado: String | null) {
    if (estado === "SENT") {
      return "ENVIADO"
    } else if (estado === "CONFIRMED") {
      return "CONFIRMADO"
    } else if (estado === "DENIED") {
      return "DENEGADO"
    } else if (estado === "STANDBY") {
      return "EN ESPERA"
    } else {
      return estado
    }

  }



  applyFilterSelect() {

    let dataNew: any = this.model

    if (this.startDateSelected && this.endDateSelected) {
      dataNew = dataNew?.filter((item: any) => {

        console.log(new Date(item.createdAt))

        return new Date(this.startDateSelected) <= new Date(item.createdAt) && new Date(item.createdAt) <= new Date(this.endDateSelected)
      })

    }

    if (this.startDateSelected2 && this.endDateSelected2) {
      dataNew = dataNew?.filter((item: any) => {

        return new Date(this.startDateSelected2) <= new Date(item.fechaPago) && new Date(item.fechaPago) <= new Date(this.endDateSelected2)
      })

    }

    if (this.selectEstadoFile) {
      dataNew = dataNew?.filter((item: any) => item.estadoFile === this.selectEstadoFile)
    }
    if (this.selectedCliente) {
      dataNew = dataNew?.filter((item: any) => item.nameEmpresa === this.selectedCliente)
    }
    if (this.selectFile) {
      dataNew = dataNew?.filter((item: any) => item.numberFile === this.selectFile)
    }
    if (this.selectProveedor) {
      dataNew = dataNew?.filter((item: any) => item.nameProveedor === this.selectProveedor)
    }
    if (this.selectService) {
      dataNew = dataNew?.filter((item: any) => item.servicio.servicio === this.selectService)
    }
    if (this.selectEstadoOS) {
      dataNew = dataNew?.filter((item: any) => this.traslateEstado(item.estadoOS) === this.selectEstadoOS)
    }
    if (this.selectOS) {
      dataNew = dataNew?.filter((item: any) => item.numberOS === this.selectOS)
    }


    console.log(dataNew)
    this.osDataSource.data = dataNew


  }



  onApplyRangeSelected() {
    console.log(this.startDate)

    this.startDateSelected = this.getDateTransform(JSON.stringify(new Date(this.startDate)))
    this.endDateSelected = this.getDateTransform(JSON.stringify(new Date(this.endDate)))
    this.applyFilterSelect()
  }

  onApplyRangeSelected2() {
    this.startDateSelected2 = this.getDateTransform(JSON.stringify(new Date(this.startDate2)))
    this.endDateSelected2 = this.getDateTransform(JSON.stringify(new Date(this.endDate2)))
    this.applyFilterSelect()
  }

  getDateTransform(date: string) {
    console.log("date", date)
    if (date) {
      const dateSeparated = date?.slice(1, 11).split('-')
      console.log(dateSeparated)
      const month = dateSeparated[1]
      const day = dateSeparated[2]
      const year = dateSeparated[0]
      return month + '/' + day + '/' + year
    }
    return null;
  }

  transformFormat(date: string) {
    if (date) {
      const dateSeparated = date?.slice(0, 10).split('-')
      console.log(dateSeparated)
      const month = dateSeparated[1]
      const day = dateSeparated[2]
      const year = dateSeparated[0]
      return month + '/' + day + '/' + year
    }
    return null;

  }

  cleanDateSelected(val: any) {

    console.log(val)
    if (val == 1) {
      this.startDate = null
      this.startDateSelected = null
      this.endDate = null
      this.endDateSelected = null
    }
    else if (val == 2) {
      this.startDate2 = null
      this.startDateSelected2 = null
      this.endDate2 = null
      this.endDateSelected2 = null
    }


    this.applyFilterSelect()

  }
}
